import { ReactNode } from 'react';

import { NOTIFICATIONS_CATEGORIES, NOTIFICATIONS_TYPES } from 'entities/Notification';
import { EBrokenLinksErrors, IBaseResponse } from 'shared/typings';

export enum ENotificationTypes {
	CUSTOM = 'custom',
	SOURCES_NOT_VERIFIED = 'source_not_verified',
	SOURCES_ON_VERIFICATION = 'source_on_verification',
	SOURCES_ON_MODERATION = 'source_on_moderation',
	SOURCES_REJECTED = 'source_rejected',
	SOURCES_ACTIVE = 'source_active',
	SOURCE_BRAND_CREATED = 'source_brand_created',
	SOURCE_OFFER_CREATED = 'source_offer_created',
	SOURCE_OFFER_JOINED = 'source_offer_joined',
	SOURCE_OFFER_REJECTED = 'source_offer_rejected',
	SOURCE_OFFER_STOPPED = 'source_offer_stopped',
	OFFER_INVITE = 'offer_invite',
	BRAND_INVITE = 'brand_invite',
	RATE_CHANGES = 'offer_rates_changes',
	NEW_OFFERS = 'new_offers',
	NEW_OFFER = 'new_offer',
	BALANCE_UPDATE = 'balance_update',
	BONUS_CREATED = 'bonus_created',
	TELEGRAM = 'telegram',
	BROKEN_LINK = 'broken_link',
}

export interface ICustomNotification {
	title: string;
	body: string;
}

export interface IChangedTariff {
	tariff: {
		code: string;
		name: string;
	};
	sources: {
		source: {
			id: string;
			name: string;
		} | null;
		current_payout: string;
		previous_payout: string | null;
	}[];
}

export interface IExtra {
	rejection_comment?: string;
	mmp_link?: string;
	cap?: number;
	en?: ICustomNotification;
	ru?: ICustomNotification;
	awaiting_payment?: string;
	ready_for_withdrawal?: string;
	amount?: string;
	action_uuid?: string;
	changes?: IChangedTariff[];
	error_code?: EBrokenLinksErrors;
	account_url?: string;
	original_url?: string;
}

export interface INotificationBrand {
	image: string;
	uuid: string;
	name: string;
}
export interface INotificationSource {
	uuid: string;
	name: string;
}

export interface INotificationOffer {
	image: string;
	uuid: string;
	name: string;
}

export interface INotification {
	id: number;
	user_id?: string;
	created_at: string;
	brand: INotificationBrand | null;
	offer: INotificationOffer | null;
	source: INotificationSource | null;
	source_id?: string;
	type: keyof ReturnType<typeof NOTIFICATIONS_TYPES>;
	category: keyof ReturnType<typeof NOTIFICATIONS_CATEGORIES>;
	alert: boolean;
	read: boolean;
	icon?: string;
	extra: IExtra | { [key: string]: string } | null;
}

export type TNotificationsList = IBaseResponse<INotification[] | null>;

export interface ISetReadRequest {
	ids: number[];
	delete_invite?: boolean;
}

export interface IUnreadCount {
	unread_count: number;
}

export type TExtra = (keyof IExtra | '')[] | ['all'];
export type TExtraValue = (IExtra | string | number | ICustomNotification | IChangedTariff[] | undefined)[];

export interface INotificationType {
	text: (
		brand: INotificationBrand | null,
		offer: INotificationOffer | null,
		source: INotificationSource | null,
		extra?: TExtraValue,
	) => ReactNode;
	title: (
		brand: INotificationBrand | null,
		offer: INotificationOffer | null,
		source: INotificationSource | null,
		extra?: TExtraValue,
	) => ReactNode;
	link?: (
		brand: INotificationBrand | null,
		offer: INotificationOffer | null,
		source: INotificationSource | null,
		actions?: (() => void)[],
		isLoading?: boolean,
	) => ReactNode;
	icon: ReactNode;
	extra: TExtra;
}
